import { URLSearchParams, QueryEncoder } from '@angular/http';
import { URLParams } from '../../../core/url-params.model';

export class ForSigningHttpUtil {

  public static prepareParamsContracts(params): URLSearchParams {
    let urlParams = new URLParams();

    if (params.securityToken) {
      urlParams.append('securityToken', params.securityToken);
    }
    return urlParams;
  }

  public static prepareParamsDecline(params) {
    let formData: FormData = new FormData();

    if (params.securityToken) {
      formData.append('securityToken', params.securityToken);
    }
    if (params.message) {
      formData.append('message', params.message);
    }
    return formData;
  }

  public static prepareParamsAgree(params) {
    let formData: FormData = new FormData();

    if (params.securityToken) {
      formData.append('securityToken', params.securityToken);
    }
    return formData;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/for-signing.util.ts